import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import FormComponent from "./components/FormComponent";
import NavbarComponent from "./components/NavbarComponent";
import Card from "./components/Card";

class App extends Component {
  state = {
    data: [],
    cards: []
  };

  render() {
    return (
      <React.Fragment>
        <NavbarComponent />
        <FormComponent onSubmit={this.onFormSubmit} />
        {this.state.cards};
      </React.Fragment>
    );
  }

  onFormSubmit = (event, countryName) => {
    event.preventDefault();
    this.state.data = [];
    this.state.cards = [];
    this.fetchData(countryName);
  };

  fetchData(countryName) {
    fetch("https://restcountries.eu/rest/v2/name/" + countryName).then(
      results => {
        results.json().then(data => {
          this.state.data = data;
          this.generateCards();
        });
      }
    );
  }

  generateCards() {
    for (let i = 0; i < this.state.data.length; i++) {
      let countryName = this.state.data[i].name;
      let countryPopulation = this.state.data[i].population;
      let countryCapital = this.state.data[i].capital;
      let countryLanguages = this.state.data[i].languages;
      let flagLink = this.state.data[i].flag;
      this.state.cards.push(
        <Card
          key={i}
          country={countryName}
          population={countryPopulation}
          capital={countryCapital}
          languages={countryLanguages}
          flag={flagLink}
        />
      );
    }
    if (this.state.cards.length === 0) {
      this.state.cards.push(
        <Card key={0} country="No Country Found" population="" />
      );
    }
    this.setState({});
  }
}

export default App;
